import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_SLIDE_TOGGLE } from '@editor/src/img/pageIndex';
import simpleSvg from '@tencent/docs-design-resources/pc/svg/menu_toolbar_view_simple.svg';
import officeSvg from '@tencent/docs-design-resources/pc/svg/menu_toolbar_view_office.svg';
import immersiveSvg from '@tencent/docs-design-resources/pc/svg/menu_toolbar_view_immersive.svg';
import { ToolbarType } from '@src/js/constant';
import { getPlatformShortcut } from '@src/js/utils';
import style from './toggle.less';
import { TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.TOOLBAR_MODE,
    tipMsg: i18n.t('工具栏切换'),
    icon: TOOLBAR_SLIDE_TOGGLE,
    twdConfig: {
        opername: TDWOperationType.DOC_WORD_EDITOR,
    },
};

export const IMMERSIVE_TOGGLE = '3';

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        hasArrow: false,
        icon: <img src={config.icon} alt={''} style={{
            transform: 'rotate(180deg)',
        }} />,
    },
];

export const MENU_CONFIG: MenuConfig[] = [
    {
        name: config.id,
    },
    {
        name: ToolbarType.SINGLE_TOOLBAR,
        content: i18n.t<string>('简约工具栏'),
        icon: <img className={style.toggleIcon} src={simpleSvg} alt={''} />,
    },
    {
        name: ToolbarType.DOUBLE_TOOLBAR,
        content: i18n.t<string>('专业工具栏'),
        icon: <img className={style.toggleIcon} src={officeSvg} alt={''}/>,
    },
    {
        name: IMMERSIVE_TOGGLE,
        content: i18n.t<string>('隐藏工具栏'),
        description: getPlatformShortcut('Cmd+F1'),
        icon: <img className={style.toggleIcon} src={immersiveSvg} alt={''}/>,
    },
];
